import {
  Avatar,
  Box,
  CircularProgress,
  Divider,
  styled,
  Typography,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useUserById } from "@/hooks/use-user-by-id";
import { formatRole } from "@/utils/format-role";
import { profileSchema } from "@/schemas/user.schema";
import { useFormik } from "formik";
import { CustomerProfileDetails } from "../_components/customer-profile-details";
import { CustomerProfileAccount } from "../_components/customer-profile-account";
import { CustomerProfileIdentity } from "../_components/customer-profile-identity";
import { CustomerProfileDevice } from "../_components/customer-profile-device";
import { CustomerProfileActivity } from "../_components/customer-profile-activity";
import { formatLabel } from "@/utils/format-label";

const SectionRoot = styled("section")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Card = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "16px 20px",
  borderRadius: "12px",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const SectionWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 3),
}));

export const Profile = () => {
  const { userId } = useParams();
  const { data, isLoading } = useUserById(userId);

  const profileFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      firstName: data?.firstName ?? "",
      lastName: data?.surname ?? "",
      email: data?.email ?? "",
      phoneNumber: data?.phoneNumber ?? "",
      address: data?.address ?? "",
      district: data?.district ?? "",
      city: data?.city ?? "",
      state: data?.state ?? "",
      gender: data?.gender ?? "",
      isActive: data?.active ?? undefined,
    },
    validationSchema: profileSchema,
    onSubmit: (values) => {
      console.log("PROFILE:", values);
    },
  });

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 2 }}>
        <CircularProgress size={16} thickness={4} />
        <Typography variant="body2" color="text.secondary">
          Loading...
        </Typography>
      </Box>
    );
  }

  if (!data) return null;

  const fullName = `${formatLabel(data?.firstName)} ${formatLabel(data?.surname)}`;
  const rolesText = data?.roles?.map(formatRole).join(", ") || "";

  return (
    <SectionRoot>
      <Card>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Avatar
            alt="user-profile-pic"
            src={""}
            sx={{ width: 72, height: 72 }}
          />
          <Box>
            <Typography variant="h5">{fullName}</Typography>
            <Typography variant="body2" color="text.secondary">
              {rolesText}
            </Typography>
          </Box>
        </Box>

        <Divider />

        <SectionWrapper>
          <form onSubmit={profileFormik.handleSubmit}>
            <CustomerProfileDetails formik={profileFormik} isDisabled={false} />
          </form>
        </SectionWrapper>

        <Divider />

        <SectionWrapper>
          <CustomerProfileAccount data={data} />
        </SectionWrapper>

        <Divider />

        <SectionWrapper>
          <CustomerProfileIdentity data={data} />
        </SectionWrapper>

        <Divider />

        <SectionWrapper>
          <CustomerProfileDevice data={data} />
        </SectionWrapper>

        <Divider />

        <SectionWrapper>
          <CustomerProfileActivity data={data} />
        </SectionWrapper>
      </Card>
    </SectionRoot>
  );
};
